























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat } from '@/utils/common'

@Component
export default class ModalProcedimentoCompartilhadoIncluir extends Vue {
  $refs: {
    formProcedimentos: any
  }

  formRules = {
    valid: false
  }

  loadAddRegraCalculoOperadora: boolean = false
  primeiraCargaTipoCompartilhamento = true

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get showModalAddProcedimentoCompartilhado() { return this.getRegrasDeCalculoStore.modal.procedimentoCompartilhado }
  set showModalAddProcedimentoCompartilhado(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'procedimentoCompartilhado', value }) }

  get percentualAplicar() { return this.getRegrasDeCalculoStore.percentualAplicar }
  set percentualAplicar(value: any) { this.getRegrasDeCalculoStore.setPercentualAplicar(value) }

  get funcoes() { return this.getRegrasDeCalculoStore.funcoesProcedimento }
  get fontesPagadoras() { return this.getRegrasDeCalculoStore.fontesPagadoras }
  get tipos() { return this.getRegrasDeCalculoStore.tipos }
  get valoresReferencia() { return this.getRegrasDeCalculoStore.valoresReferencia }

  get funcaoProcOrigem() { return this.getRegrasDeCalculoStore.funcaoProcOrigem }
  set funcaoProcOrigem(value: any) { this.getRegrasDeCalculoStore.setFuncaoProcOrigem(value) }

  get funcaoProcDestino() { return this.getRegrasDeCalculoStore.funcaoProcDestino }
  set funcaoProcDestino(value: any) { this.getRegrasDeCalculoStore.setFuncaoProcDestino(value) }

  get fontePagadoraField() { return this.getRegrasDeCalculoStore.fontePagadoraField }
  set fontePagadoraField(value: any) { this.getRegrasDeCalculoStore.setFontePagadoraField(value) }

  get tipoField() { return this.getRegrasDeCalculoStore.tipoField }
  set tipoField(value: any) { this.getRegrasDeCalculoStore.setTipoField(value) }

  get valorReferencia() { return this.getRegrasDeCalculoStore.valorReferencia }
  set valorReferencia(value: any) { this.getRegrasDeCalculoStore.setValorReferencia(value) }
  get tipoCompartilhamento() { return this.getRegrasDeCalculoStore.tipoCompartilhamento }
  set tipoCompartilhamento(value: any) { this.getRegrasDeCalculoStore.setTipoCompartilhamento(value) }

  get codigoProcedimento() { return this.getRegrasDeCalculoStore.codigoProcedimento }
  set codigoProcedimento(value: any) { this.getRegrasDeCalculoStore.setCodigoProcedimento(value) }

  get grupoRepasse() { return this.getRegrasDeCalculoStore.grupoRepasse }
  set grupoRepasse(value: any) { this.getRegrasDeCalculoStore.setGrupoRepasse(value) }

  get subGrupoRepasse() { return this.getRegrasDeCalculoStore.subGrupoRepasse }
  set subGrupoRepasse(value: any) { this.getRegrasDeCalculoStore.setSubGrupoRepasse(value) }

  get isEditMode() { return this.getRegrasDeCalculoStore.modalProcedimentoCompartilhadoMode }

  get loadingAddRegraCalculo() { return this.loadAddRegraCalculoOperadora }
  set loadingAddRegraCalculo(value: boolean) { this.loadAddRegraCalculoOperadora = value }

  get gruposRepasse() { return this.getRegrasDeCalculoStore.gruposRepasse }
  get subGruposRepasse() { return this.getRegrasDeCalculoStore.subGruposRepasse }

  get tiposCompartilhamento() {
    return [
      { key: 'Funcao', display: 'Função' },
      { key: 'Codigo', display: 'Código' }
    ]
  }

  async onChangeGrupo() {
    this.subGrupoRepasse = null

    if (this.grupoRepasse) {
      await this.getRegrasDeCalculoStore.getSubGruposRepasse(this.grupoRepasse)
    }
  }

  onlyFloatUtil(value: number) { return onlyFloat(value) }

  async addProcedimento() {
    this.loadingAddRegraCalculo = true

    if (this.subGrupoRepasse && !this.grupoRepasse) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Preencha o Grupo Repasse antes de selecionar um Subgrupo.',
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculo = false
      return
    }

    const request = await this.getRegrasDeCalculoStore.addProcedimentoCompartilhado()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} 😕`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculo = false
      return
    }

    EventBus.$emit('setSnackbar', {
      show: true,
      text: 'Procedimento incluído com sucesso. 🙂',
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculo = false
    this.showModalAddProcedimentoCompartilhado = false
  }

  @Watch('showModalAddProcedimentoCompartilhado')
  onCloseModal(value: boolean) {
    if (!value) {
      this.funcaoProcOrigem = ''
      this.funcaoProcDestino = ''
      this.percentualAplicar = 0
      this.fontePagadoraField = null
      this.tipoField = null
      this.valorReferencia = null
      this.grupoRepasse = null
      this.subGrupoRepasse = null
      this.codigoProcedimento = ''
      this.tipoCompartilhamento = null
      this.primeiraCargaTipoCompartilhamento = true
      this.$refs.formProcedimentos.resetValidation()
    }
  }

  @Watch('tipoCompartilhamento')
  onTipoCompartilhamentoChange(value: any) {
    if (value === null || value === undefined) return
    
    if (this.primeiraCargaTipoCompartilhamento) {
      this.primeiraCargaTipoCompartilhamento = false
      return
    }

    if (value) {
      this.funcaoProcOrigem = null
      this.funcaoProcDestino = null
      this.codigoProcedimento = null
    }
  }

  async mounted() {
    await this.getRegrasDeCalculoStore.getFuncoesProcedimento()
    await this.getRegrasDeCalculoStore.getFontesPagadoras()
    await this.getRegrasDeCalculoStore.getGruposRepasse()
  }
}
